import React, { useEffect } from 'react';

import "./ProfileButton.scss";
import { page } from '../../../assets/bases/page';


export const ProfileButton = (props)=>{
    const { onClick } = props;
    const [ pathname ] = page.use("pathname");

    const opened = pathname.get() === "/me";

    return (
        <div className={`ProfileButton${opened ? " active" : ""}`} onClick={onClick}>
            {props.children}
        </div>
    )
}

